import { useCallback } from "react";

import { apiClient } from "../../lib/api";

import type { ApiPayload } from "common/classes/api-payload";

export function useChangePassword(): (oldPassword: string, newPassword: string) => Promise<ApiPayload> {
  const changePassword = useCallback(async (oldPassword: string, newPassword: string): Promise<ApiPayload> => {
    const response = await apiClient.changePassword(oldPassword, newPassword);

    if (!response.success) {
      throw new Error(response.message ?? `unexpectedError`);
    }

    return response;
  }, []);

  return changePassword;
}
